import { render, staticRenderFns } from "./AcademyScheduleList.vue?vue&type=template&id=95adab72&scoped=true"
import script from "./AcademyScheduleList.vue?vue&type=script&lang=js"
export * from "./AcademyScheduleList.vue?vue&type=script&lang=js"
import style0 from "./AcademyScheduleList.vue?vue&type=style&index=0&id=95adab72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95adab72",
  null
  
)

export default component.exports